import { Slot } from './interface';

export const getCompleteData = async (
  params?: Record<string, any>,
  headers?: HeadersInit,
) => {
  const queryParams = new URLSearchParams({
    action: 'content',
    ...params,
  }).toString();
  const url = `/api/app-wrapper?${queryParams}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...(headers || {}),
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw {
      status: response.status,
      message: errorData?.errorMessage || 'Failed to fetch content',
      raw: errorData,
    };
  }

  return response.json();
};

export const getSlots = async (
  params?: Record<string, any>,
): Promise<Slot[]> => {
  const queryParams = new URLSearchParams({
    action: 'slots',
    ...params,
  }).toString();
  const url = `/api/app-wrapper?${queryParams}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw {
      status: response.status,
      message: errorData?.errorMessage || 'Failed to fetch slots',
      raw: errorData,
    };
  }

  return response.json();
};

export const makeReservation = async (
  payload: any,
  params?: Record<string, any>,
  headers?: HeadersInit,
) => {
  const response = await fetch('/api/app-wrapper', {
    method: 'POST',
    body: JSON.stringify({
      ...payload,
      queryParams: params,
    }),
    headers: {
      'Content-Type': 'application/json',
      ...(headers || {}),
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw {
      status: response.status,
      message: errorData?.errorMessage || 'Failed to create reservation',
      raw: errorData,
    };
  }

  return response.json();
};

export const claimAntavoReward = async (
  payload: { resourceId: string },
  headers?: HeadersInit,
) => {
  const response = await fetch('/api/app-wrapper', {
    method: 'POST',
    body: JSON.stringify({ action: 'antavoClaim', ...payload }),
    headers: {
      'Content-Type': 'application/json',
      ...(headers || {}),
    },
  });

  const responseText = await response.text();
  let responseData: any;
  try {
    responseData = JSON.parse(responseText);
  } catch {
    const contentType = response.headers.get('content-type') || 'unknown';
    const redirectedTo = response.redirected
      ? `; redirected to ${new URL(response.url).pathname}`
      : '';
    throw {
      status: response.status,
      message: `Expected JSON from claim endpoint, received ${contentType} (HTTP ${response.status})${redirectedTo}`,
      raw: {
        contentType,
        redirected: response.redirected,
        url: response.url,
      },
    };
  }

  if (!response.ok) {
    throw {
      status: response.status,
      message:
        responseData?.errorMessage ||
        responseData?.message ||
        'Failed to claim offer',
      raw: responseData,
    };
  }

  return responseData;
};

